// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"22":"97fae0f6","319":"fe1760cd"}[chunkId] + ".chunk.css";
};